import { css } from "@vitality-ds/system";
export default css({
  alignItems: "center",
  display: "flex",
  height: "100%",
  justifyContent: "center",
  width: "100%"
});